/** Listing slug for the workspace shown in the CRM dashboard account switcher. */
export const CRM_LISTING_ID = 'z-pet-hotels'

/** Fallbacks when listing data is unavailable at build/runtime. */
export const CRM_ACCOUNT_NAME = 'Z Pet Hotels'

export const CRM_ACCOUNT_LOGO = '/images/z-pet-hotels-logo.png'

export function accountLogoUrl(name) {
  if (!name || !String(name).trim()) return null
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(
    String(name).trim()
  )}&background=50b864&color=fff&size=128`
}
